<div *ngIf="(listaRelacionados.padre.length > 0 || listaRelacionados.hijos.length > 0)">
    <mat-toolbar>
        <span>Registros Relacionados</span>
        <span class="spacer"></span>
    </mat-toolbar>
    <div class="p-5 bg-white w-full">
        <div class="flex pl-5 pr-5">
            <table class="tblRegistrosRelacionados">
                @for (item of listaRelacionados.padre; track $index) {
                    <tr>
                        <td>RI</td>
                        <td>{{ getStatus(item)}} </td>
                        <td>
                            <a target="_blank" href="/entrada/{{item.tema}}/{{item.idEntrada}}" title="{{item.asunto}}">
                                {{ item.asunto?.toUpperCase() }}
                            </a>
                        </td>
                    </tr>
                }
                @for (item of listaRelacionados.hijos; track $index) {
                    <tr>
                        <td>RR {{item.orden+1}}</td>
                        <td>{{getStatus(item)}}</td>
                        <td>
                            <a target="_blank" href="/entrada/{{item.tema}}/{{item.idEntrada}}" title="{{item.asunto}}">
                                {{ item.asunto?.toUpperCase() }}
                            </a>
                        </td>
                    </tr>
                }
            </table>
        </div>
    </div>
</div>